
// Code for hiding elements according to region

console.log("region " + pageRegion);
console.log("lang " + pageLang);

if (pageRegion === "GB") {
  console.log('Page region UK')
  const menuItems = document.querySelectorAll('ul.list-menu li.menu-lv-item');
  menuItems[4].style.display = 'none';
  //    if (window.location.pathname === '/en-uk/pages/where-to-buy') {
  //     window.location.href = 'https://www.littergenie.com/en-uk';
  // }
}

var url = window.location.href;
var section = document.getElementById("littergenie-cares");
var reviews = document.querySelector('.product-tab-item.review');
var headerDescription = document.querySelector('.header-description');
var videoDescription = document.querySelector('.video-description');
var question = document.getElementById('question-15d9d2f4-1bdd-49c8-9a99-58246020f05c-3');
var comparison_table = document.querySelector('.comparison-content');
var whereToBuy = document.querySelector('.where-to-buy-container');
var partnersLink = document.querySelector('#shopify-section-footer > footer > div > div > div > div:nth-child(4)');
var listItems = partnersLink.querySelectorAll('li');
var frenchHeading = document.getElementById('shopify-section-template--17264834052377__5a2c91a3-78e3-47dd-80d9-d34147becef2');
var reviewsSectionHomepage = document.querySelector('.litter-genie-sections-customer-review-block');
var accessoriesLink = document.querySelector('#shopify-section-footer > footer > div > div > div > div:nth-child(3) > div > div > ul > li:nth-child(3)');
var subMenu = document.querySelector('#shopify-section-header-02 > div > header > div.wrapper-header-bottom > div > div > div.main-menu.header-bottom-center > div > nav > ul > li.menu-lv-item.menu-lv-1.text-left.no-megamenu.dropdown > ul')
var subscribeBanner = document.getElementById('subscribe-container');
const menu = document.querySelector('.list-menu.list-menu--inline.text-left');


// if(pageRegion === "US" || pageRegion === "GB" || pageRegion === "DE" || pageRegion === "FR"){
//       menu.children[2].style.display = 'none';
// }

// if (pageRegion === "GB" || pageRegion === "DE" || pageRegion === "FR") {
//   document.querySelector(
//     "#shopify-section-footer > footer > div > div > div > div:nth-child(4) > div > div > ul > li:nth-child(5)"
//   ).style.display = 'none';
// }

if (window.location.pathname === '/en-uk/pages/quarterly-contest') {
  window.location.href = 'https://www.littergenie.com/en-uk';
}

if (window.location.pathname === '/fr-fr/pages/quarterly-contest') {
  window.location.href = 'https://www.littergenie.com/fr-fr';
}

if (window.location.pathname === '/de-de/pages/quarterly-contest') {
  window.location.href = 'https://www.littergenie.com/de-de';
}


if (pageRegion == "FR") {
  $("#MenuMobileListSection-menu li:eq(2)").hide();
}

//Add class to style the german blog page
if (pageLang == "de") {
  $('.main-blog').addClass('german-blog');
}

if (pageRegion == "DE" || pageRegion == "GB" || pageRegion == "FR") {
  if (url.includes("contact")) {
    $('.footer').addClass('support-faq-margin');
  }
  if (reviewsSectionHomepage) {
    reviewsSectionHomepage.style.display = 'none';
  }
}

//Add class to footer in support page

// Check if the current page URL contains "support-faq"
if (url.includes("support-faq")) {
  // Add a class to the footer element
  $(".footer").addClass("support-faq-footer");
}



// Hide Partners Link from footer
if (pageRegion == "DE" || pageRegion === "GB" || pageRegion == "FR") {
  // if (listItems.length >= 4) {
  //   listItems[1].style.display = 'block';
  // }
  $(".faqs-row .faqs-item:eq(2)").hide();
}


// FUNCTION TO HIDE ACCESSIORIES LINK FROM CANANDIAN MARKET ON NAV, MOBILE NAV AND FOOTER

// if( pageRegion === "CA") {
//   //  accessoriesLink.style.display = "none";
//   // $('.list-menu li:eq(2)').hide();

//   // document.addEventListener("DOMContentLoaded", function() {
//   //   var style = document.createElement("style");
//   //   style.textContent = "#MenuMobileListSection-menu > li:nth-child(3) { display: none; }";
//   //   document.head.appendChild(style);
//   // });
// }



// Create a URL object
var parsedUrl = new URL(url);

// Get the region from the URL
var region = parsedUrl.pathname.split('/')[1];

// ADD CLASSES TO PRODUCT CARD ACCORDING TO REGION
if (pageRegion == "US") {
  $("div.card-product").addClass("us-product");
  // console.log($("div.card-product"));
  $("div.product-card-copy").addClass('us-product-copy');
}

// if (pageRegion == "GB") {
//   $("#shopify-section-footer > footer > div > div > div > div:nth-child(4) > div > div > ul > li:nth-child(1)").hide();
//   subscribeBanner.style.display = "block";
// }


if (pageRegion === "GB" || pageRegion === "CA" || pageRegion === "FR" || pageRegion == "DE") {
  if (section) {
    section.style.display = "none"
  }
} else {
  if (section) {
    section.style.display = "block"
  }
}


if (pageRegion === "GB" || pageRegion === "FR" || pageRegion == "DE") {

  console.log('sub', $('ul.header__submenu.list-menu.list-menu--disclosure.list-menu--disclosure-1.caption-large.motion-reduce'))
  subMenu.style.display = 'none';;

  if (reviews) {
    reviews.style.display = "none"
  }

  if (question) {
    question.style.display = "none";
  }

  if (comparison_table) {
    comparison_table.style.width = "35%"
  }

}


if (pageRegion == "CA" && pageLang == "fr") {
  if (headerDescription) {
    headerDescription.style.display = "block";
  }
}

if (pageLang == "fr") {
  if (frenchHeading) {
    frenchHeading.classList.add('french-heading-style');
  }
}



// petgenie nav link
let petGenie = document.querySelector('[href*="petwastegenie.com"]');
petGenie.setAttribute('target', '_blank');
petGenie.setAttribute('rel', 'noopener');

if (pageRegion === "CA" && pageLang === "en") {
  if (petGenie) {
    petGenie.href = "https://petwastegenie.com/en-ca";
  }

}

if (pageRegion === "CA" && pageLang === "fr") {

  if (petGenie) {
    petGenie.href = "https://petwastegenie.com/fr-ca";
  }

}

if (pageRegion === "DE") {

  if (petGenie) {
    petGenie.href = "https://petwastegenie.com/de-de";
  }
}

if (pageRegion === "FR") {

  if (petGenie) {
    petGenie.href = "https://petwastegenie.com/fr-fr";
  }
}

if (pageRegion === "GB") {

  if (petGenie) {
    petGenie.href = "https://petwastegenie.com/en-uk";
  }

}

const grid = document.querySelector(".how-to-use-section-grid");
if (grid) {
  const items = grid.children.length; // Count items
  if (items === 3) {
    grid.style.gridTemplateColumns = "repeat(3, 1fr)";
  }
}

if (pageRegion === "CA" && pageLang === "fr") {
  $(".social-icons-nav").addClass("ca-fr-nav");
}
